export const chatbotModalIntegrationCookieName =
	'ChatbotModalIntegrationIsDismissed';
